import { createDexCexFilters } from '@/filters/dexCexFilters'
import type { useDexCexAlertsStore } from '@/stores/dexCexAlertsStore'
import { split, keysToSnake, strToNumber, parseCommaSeparatedAssets } from '@/utils'
import { extractFormData, extractZodFromForm } from '@/utils/forms'
import { ref } from 'vue'
import z from 'zod'

export function useDexCexFilters(store: ReturnType<typeof useDexCexAlertsStore>) {
  const filters = createDexCexFilters()
  const initValues = extractFormData(filters)
  const formData = ref({ ...initValues })
  const zodForm = z.object(extractZodFromForm(filters))

  const loadFiltersFromSettings = (settings: Record<string, string>) => {
    const cachedFilters = {
      // dexs: null as string[] | null,
      cexs: null as string[] | null,
      symbols: null as string | null,
      spreadMin: null as number | null,
      excludeSelectedSymbols: null as boolean | null,
      vol24hCexMin: null as number | null,
      isLong: null as number | null,
      volumes: null as number | null,
      vol24hDexMin: null as number | null,
      maxAgeSeconds: null as number | null,
    }

    // cachedFilters.dexs = settings.dex_cex_filter_dexs?.split(',') ?? null

    cachedFilters.cexs = split(settings.dex_cex_filter_cexs)
    cachedFilters.symbols = settings.dex_cex_filter_symbols ?? null
    cachedFilters.spreadMin = strToNumber(settings.dex_cex_filter_spread_min)
    cachedFilters.excludeSelectedSymbols =
      strToNumber(settings.dex_cex_filter_exclude_symbols, 0) == 1
    cachedFilters.vol24hCexMin = strToNumber(settings.dex_cex_filter_vol24h_cex_min)
    cachedFilters.vol24hDexMin = strToNumber(settings.dex_cex_filter_vol24h_dex_min)
    cachedFilters.isLong = strToNumber(settings.dex_cex_filter_is_long)
    cachedFilters.volumes = strToNumber(settings.dex_cex_filter_volumes)
    cachedFilters.maxAgeSeconds = strToNumber(settings.dex_cex_filter_max_age_seconds)

    const toBeInForm = {
      ...formData.value,
      ...cachedFilters,
    } as Record<string, any> // eslint-disable-line
    formData.value = toBeInForm

    const snaked = keysToSnake(cachedFilters) as Record<string, any>
    if (typeof snaked.symbols === 'string') {
      snaked.symbols = parseCommaSeparatedAssets(snaked.symbols)
    }
    store.filters = {
      ...store.filters,
      ...snaked,
    }
  }

  return { formData, zodForm, loadFiltersFromSettings, filters }
}
